module.exports = __webpack_public_path__ + "img/logo-main-responsiva.ade325dd.png";